import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@sendgrid/style-guide-grid';
import { Select } from '@sendgrid/ui-components/select';
import ProfileTooltip from './ProfileTooltip';
import withProfileInputs from '../containers/withProfileInputs';
import PROFILE from '../constants/profile';
import Styles from './g2gProfileExp.module.scss';
import profileTooltip from '../constants/profileTooltip';
import { createSelectOptions } from '../utils/createSelectOptions';

export const G2gExpCompanyInfo = (props) => {
  const companyInfo = [
    PROFILE.LV_EMPLOYEE,
    PROFILE.MLV_EMPLOYEE,
    PROFILE.MHV_EMPLOYEE,
    PROFILE.HV_EMPLOYEE,
  ];

  const companyInfoOptions = createSelectOptions(companyInfo);

  return (
    <section className={Styles['profile-component']}>
      <div className={Grid.row} data-role="company-info-container">
        <div className={`${Styles['form-prompt']} ${Grid['col-12']}`} data-role="employee-count-prompt">
          How many employees work at your company?
          <span className={Styles['required-dot']}>&bull;</span>
          <ProfileTooltip content={profileTooltip.COMPANY_INFO} />
        </div>
        <div className={Grid['col-12']}>
          <Select
            placeholder="Select a value"
            required="true"
            options={companyInfoOptions}
            onChange={props.setEmployeeCount}
          />
        </div>
      </div>
    </section>
  );
};

G2gExpCompanyInfo.propTypes = {
  setEmployeeCount: PropTypes.func.isRequired,
  profileInputs: PropTypes.shape({
    employeeCount: PropTypes.string.isRequired,
  }).isRequired,
};

export default withProfileInputs(G2gExpCompanyInfo);
